enum DeliveryMethod {
  SERVE = "serve",
  PICKUP = "pickup"
};

export default DeliveryMethod;